import React, { useEffect, useState } from "react";
import { Download, Edit, Plus, FileText } from "lucide-react";
import { Link } from "react-router-dom"; 
import { useAdminAuth } from "../../context/AdminAuthContext"; 

const QuotationList = () => {
  const { token } = useAdminAuth(); 
  const [quotations, setQuotations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if(token) {
        fetchQuotations();
    }
  }, [token]);

  const fetchQuotations = async () => {
    try {
      const res = await fetch("https://luxuriyahomes.com/api/quotations/all", {
        headers: {
            "Authorization": `Bearer ${token}`,
        }
      });

      if(res.ok){
          const data = await res.json();
          setQuotations(data.sort((a:any, b:any) => b.id - a.id));
      }
    } catch (error) {
      console.error("Error fetching quotations", error);
    } finally {
        setLoading(false);
    }
  };

  // --- UPDATED DOWNLOAD FUNCTION (FIXED) ---
  const handleDownload = async (id: number, clientName: string) => {
      try {
          const res = await fetch(`https://luxuriyahomes.com/api/quotations/download/${id}`, {
              method: 'GET',
              headers: {
                  'Authorization': `Bearer ${token}`, // Token bhejna zaroori hai
              }
          });

          if (res.ok) {
              // 1. Convert response to Blob (File object)
              const blob = await res.blob();
              
              // 2. Create a temporary URL
              const url = window.URL.createObjectURL(blob);
              
              // 3. Create a hidden link and click it
              const a = document.createElement('a');
              a.href = url;
              a.download = `Quote_${clientName.replace(/\s+/g, '_')}.pdf`; // Filename set karo
              document.body.appendChild(a);
              a.click();
              
              // 4. Cleanup
              window.URL.revokeObjectURL(url);
              document.body.removeChild(a);
          } else {
              alert("Download Failed! File might not exist.");
          }
      } catch (error) {
          console.error("Download error:", error);
          alert("Error downloading file.");
      }
  };

  return (
    <div className="min-h-screen bg-black text-white p-8">
      <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-center mb-8">
            <div>
                <h1 className="text-3xl font-bold text-white mb-2">My Quotations</h1>
                <p className="text-zinc-500">Manage and download your client estimates</p>
            </div>
            <Link to="/create-quotation" className="bg-amber-600 px-6 py-3 rounded hover:bg-amber-500 text-black font-bold flex items-center gap-2 transition">
              <Plus size={20} /> Create New
            </Link>
          </div>

          <div className="bg-[#161616] rounded-lg border border-zinc-800 overflow-hidden">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-zinc-900 text-zinc-400 text-xs uppercase tracking-wider">
                  <th className="p-4 border-b border-zinc-800">#ID</th>
                  <th className="p-4 border-b border-zinc-800">Date</th>
                  <th className="p-4 border-b border-zinc-800">Client Name</th>
                  <th className="p-4 border-b border-zinc-800">Site Address</th>
                  <th className="p-4 border-b border-zinc-800 text-right">Amount</th>
                  <th className="p-4 border-b border-zinc-800 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                    <tr><td colSpan={6} className="p-8 text-center text-zinc-500">Loading...</td></tr>
                ) : quotations.map((q: any) => (
                  <tr key={q.id} className="hover:bg-zinc-800/30 border-b border-zinc-800/50 transition">
                    <td className="p-4 text-zinc-500 text-xs">#{q.id}</td>
                    <td className="p-4 text-zinc-300 font-mono text-sm">{q.date}</td>
                    <td className="p-4 font-bold text-white">{q.clientName}</td>
                    <td className="p-4 text-zinc-400 text-sm truncate max-w-[200px]">{q.siteAddress}</td>
                    <td className="p-4 text-right font-bold text-amber-500">₹ {q.finalTotal?.toLocaleString()}</td>
                    <td className="p-4 flex justify-center gap-2">
                      
                      {/* Download Button with FIX */}
                      <button 
                        onClick={() => handleDownload(q.id, q.clientName)}
                        className="p-2 bg-zinc-800 hover:bg-blue-600/20 hover:text-blue-400 rounded text-zinc-400 transition"
                        title="Download PDF"
                      >
                        <Download size={18} />
                      </button>

                      {/* Edit Button */}
                      <Link 
                        to={`/edit-quotation/${q.id}`} 
                        className="p-2 bg-zinc-800 hover:bg-amber-600/20 hover:text-amber-500 rounded text-zinc-400 transition"
                        title="Edit"
                      >
                        <Edit size={18} />
                      </Link>

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {!loading && quotations.length === 0 && (
                <div className="p-12 text-center text-zinc-500 flex flex-col items-center">
                    <FileText size={48} className="mb-4 opacity-20" />
                    No quotations found. Create one to get started.
                </div>
            )}
          </div>
      </div>
    </div>
  );
};

export default QuotationList;